import Icon, { IconProps, IconsVariant } from "@/Components/Icon/Icon";
import React from "react";
import { cn } from "@/shared/utils/cn";

interface Props extends IconProps {
  bg?: string;
}

const widthToClass = (width: string | number): string => {
  const w = typeof width === "number" ? `${width}px` : width;
  if (w === "1rem") return "h-4 w-4";
  if (w === "1.75rem") return "h-7 w-7";
  if (w === "2rem") return "h-8 w-8";
  return `h-[${w}] w-[${w}]`;
};

const AlertIcon = ({
  variants = "bell",
  width = "1rem",
  fill = "error",
  bg = "white",
  className,
  ...props
}: Props) => {
  const fillStr = fill != null ? String(fill) : "error";
  const fillCls =
    fillStr.startsWith("#") || fillStr.startsWith("var(")
      ? ""
      : `fill-${fillStr.replace(/_/g, "-")}`;

  return (
    <div
      className="animate-pulse flex h-10 w-10 items-center justify-center rounded-full"
      style={{ backgroundColor: typeof bg === "string" ? bg : undefined }}
    >
      <Icon
        className={cn(widthToClass(width), fillCls, className)}
        style={
          fillStr.startsWith("#") || fillStr.startsWith("var(")
            ? { fill: fillStr }
            : undefined
        }
        variants={variants as IconsVariant}
        {...props}
      />
    </div>
  );
};

export default AlertIcon;
